import React, { useState, useEffect } from 'react';
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
} from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import {
  LicensingScreenContainer,
  PaymentScreen,
  SubmissionScreen,
  ConfirmationScreen,
} from '../screens';

import { licensingURL } from '../constants';

const ArticleLicensingRoutes = () => {
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const navigate = useNavigate();
  const { stripePublicKey } = window.articleLicensing;
  const stripePromise = loadStripe(stripePublicKey);

  useEffect(() => {
    if (isInitialLoad) {
      // Replace the initial Django route with '/submit' in the history
      setIsInitialLoad(false);
      navigate(`${licensingURL}/submit`, { replace: true });
    }
  }, [isInitialLoad]);

  return (
    <Routes>
      {/* If at any point a user tries to get to the base route, redirect to the form */}
      <Route exact path={`${licensingURL}/`} element={<Navigate to="submit" />} />
      <Route path={`${licensingURL}`} element={<LicensingScreenContainer />}>
        <Route path="submit" element={<SubmissionScreen />} />
        <Route
          path="payment"
          element={(
            <Elements stripe={stripePromise}>
              <PaymentScreen />
            </Elements>
          )}
        />
        {/* If a user tries to access just the base route with checkout token,
        redirect to the confirmation page */}
        <Route exact path=":token" element={<Navigate to="confirmation" />} />
        <Route path=":token">
          <Route path="confirmation" element={<ConfirmationScreen />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default ArticleLicensingRoutes;
